import { render, staticRenderFns } from "./barCodeScanningGunBinding.vue?vue&type=template&id=4b3ac400&scoped=true&"
import script from "./barCodeScanningGunBinding.vue?vue&type=script&lang=js&"
export * from "./barCodeScanningGunBinding.vue?vue&type=script&lang=js&"
import style0 from "./barCodeScanningGunBinding.vue?vue&type=style&index=0&id=4b3ac400&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3ac400",
  null
  
)

export default component.exports